import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useHistory, useParams,useLocation } from "react-router";
import styles from "./RegisterMembers.module.css";
import {
  Box,
  Divider,
  InputLabel,
  MenuItem,
  TextField,
  FormControl,
  Autocomplete,
  Button,
  Typography,
  Alert,
  AlertTitle,
  Stack,
  Card,
  CardContent,
  Grid,
  InputAdornment,
} from "@mui/material";
// import { PhotoCamera, BorderColor } from "@mui/icons-material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import axios from "axios";
import { baseUrl, requestID } from "../../common/utils";
import CircularProgress from "@mui/material/CircularProgress";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { PhotoCamera } from "@mui/icons-material";

const userSchema = yup
  .object({
    accountName: yup.string().required("Account Name is required."),
    accountNumber: yup.number().required("Account Number is required."),
    area: yup.string().required("Area is required."),
    bankName: yup.string().required("Bank Name is required."),
    businessAddress: yup.string().required("Business Address is required."),

    bvn: yup
      .string()
      .required("Next of Kin Phone is required.")
      .matches(/^\d{10}$/, "bvn must be a 10-digit number"),
    churchAddress: yup.string().required("Church Address is required."),
    dob: yup.string().required("Date of Birth is required."),
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required."),
    firstName: yup.string().required("First Name is required."),
    lastName: yup.string().required("Last Name is required."),
    lga: yup.string().required("LGA is required."),
    middleName: yup.string().optional(),
    nextOfKin: yup.string().required("Next of Kin is required."),
    nextOfKinAddress: yup.string().required("Next of Kin Address is required."),
    nextOfKinPhone: yup
      .string()
      .required("Next of Kin Phone is required.")
      .matches(/^\d{11}$/, "Next of Kin Phone must be a 11-digit number"),
    nextOfKinRelationship: yup
      .string()
      .required("Next of Kin Relationship is required."),
    parish: yup.string().required("Parish is required."),
    password: yup
      .string()
      .min(6, "Password must be at least 6 characters long")
      .required("Password is required."),
    pastorName: yup.string().required("Pastor Name is required."),
    pastorPhone: yup
      .string()
      .required("Pastor Phone is required.")
      .matches(/^\d{11}$/, "Pastor Phone must be a 11-digit number"),
    phone: yup
      .string()
      .required("Phone is required.")
      .matches(/^\d{11}$/, "Phone must be a 11-digit number"),
    province: yup.string().required("Province is required."),
    residentialAddress: yup
      .string()
      .required("Residential Address is required."),
    savingAmount: yup.string().required("Saving Amount is required."),
    securityAnswer1: yup.string().required("Security Answer 1 is required."),
    securityAnswer2: yup.string().required("Security Answer 2 is required."),
    securityQuestion1: yup
      .string()
      .required("Security Question 1 is required."),
    securityQuestion2: yup
      .string()
      .required("Security Question 2 is required."),
    titles: yup.string().required("Titles are required."),
    unitHeadName: yup.string().required("Unit Head Name is required."),
    unitHeadPhone: yup
      .string()
      .required("Unit Head Phone is required.")
      .matches(/^\d{11}$/, "Unit Head Phone must be a 11-digit number"),
    zone: yup.string().required("Zone is required."),
  })
  .required();

const RegisterMembers = () => {
  // const navigate = useNavigate()
  const url = "http://localhost/rmfwarri";
  const history = useHistory();

  // const { name } = useParams<{ name: string }>();
  const location = useLocation();
  const name = location.pathname.split("/").pop()?.replace(/%20/g, " ") || "Register Members";
  const [firstName, setFirstName] = useState<string>("");
  const [middleName, setMiddleName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [titles, setTitles] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [bvn, setBvn] = useState<string>("");
  const [lga, setLga] = useState<string>("");
  const [dob, setDob] = React.useState<Dayjs | null>(dayjs("2022-04-17"));
  const [residentialAddress, setResidentialAddress] = useState<string>("");
  const [churchAddress, setChurchAddress] = useState<string>("");
  const [zone, setZone] = useState<string>("");
  const [province, setProvince] = useState<string>("");
  const [area, setArea] = useState<string>("");
  const [parish, setParish] = useState<string>("");
  const [nextOfKin, setNextOfKin] = useState<string>("");
  const [nextOfKinRelationship, setNextOfKinRelationship] =
    useState<string>("");
  const [nextOfKinAddress, setNextOfKinAddress] = useState<string>("");
  const [nextOfKinPhone, setNextOfKinPhone] = useState<string>("");
  const [accountName, setAccountName] = useState<string>("");
  const [bankName, setBankName] = useState<string>("");
  const [savingAmount, setSavingAmount] = useState<string>("");
  const [accountNumber, setAccountNumber] = useState<string>("");
  const [unitHeadName, setUnitHeadName] = useState<string>("");
  const [unitHeadPhone, setUnitHeadPhone] = useState<string>("");
  const [pastorName, setPastorName] = useState<string>("");
  const [pastorPhone, setPastorPhone] = useState<string>("");
  const [businessAddress, setBusinessAddress] = useState<string>("");
  const [securityQuestion1, setSecurityQuestion1] = useState<string>("");
  const [securityAnswer1, setSecurityAnswer1] = useState<string>("");
  const [securityQuestion2, setSecurityQuestion2] = useState<string>("");
  const [securityAnswer2, setSecurityAnswer2] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [status, setStatus] = useState({ loading: false, error: false });
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [allSecurityQuestions, setAllSecurityQuestion] = useState<string[]>([]);
  const [file, setFile] = useState(null);
  const [signature, setSignature] = useState<File | null>(null);
  // const [signatures, setSignatures] = useState([]);
  const [signatures, setSignatures] = useState<File[]>([]);
  // const [file, setFile] = useState<File | null>(null);

  const getSecurityQuestion = async () => {
    const formData = new FormData();
    formData.append("requestID", requestID());
    const response = await axios.post(
      baseUrl() + "settings/getSecurityQuestions",
      formData
    );
    const { data } = await response.data;
    setAllSecurityQuestion(data);
    // console.log(response);
  };

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(userSchema),
  });

  const onRegisterHandler = async () => {
    setStatus({ loading: true, error: false });
    const formattedDate = dob ? dob.toISOString().split("T")[0] : null;
    const formData = new FormData();
    formData.append("requestID", requestID());
    formData.append("firstName", firstName);
    formData.append("middleName", middleName);
    formData.append("lastName", lastName);
    formData.append("titles", titles);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("dob", formattedDate);
    formData.append("bvn", bvn);
    formData.append("lga", lga);
    formData.append("residentialAddress", residentialAddress);
    formData.append("churchAddress", churchAddress);
    formData.append("zone", zone);
    formData.append("province", province);
    formData.append("area", area);
    formData.append("parish", parish);
    formData.append("nextOfKin", nextOfKin);
    formData.append("nextOfKinRelationship", nextOfKinRelationship);
    formData.append("nextOfKinPhone", nextOfKinPhone);
    formData.append("nextOfKinAddress", nextOfKinAddress);
    formData.append("accountName", accountName);
    formData.append("accountNumber", accountNumber);
    formData.append("bankName", bankName);
    formData.append("savingAmount", savingAmount);
    formData.append("unitHeadName", unitHeadName);
    formData.append("unitHeadPhone", unitHeadPhone);
    formData.append("pastorName", pastorName);
    formData.append("pastorPhone", pastorPhone);
    formData.append("businessAddress", businessAddress);
    formData.append("securityQuestion1", securityQuestion1);
    formData.append("securityAnswer1", securityAnswer1);
    formData.append("securityQuestion2", securityQuestion2);
    formData.append("securityAnswer2", securityAnswer2);
    formData.append("password", password);
    if (file && signatures) {
      formData.append("certificate", file);
      // formData.append("signature", signatures);
       signatures.forEach((sig, index) => {
    formData.append("signature", sig); 
    // or use: formData.append(`signatures[${index}]`, sig);
  });
    }
    const response = await axios.post(
      baseUrl() + "users/registerMember",
      formData
    );
    console.log(response);
    const data = await response.data;
    setStatus({ loading: false, error: false });
    if (data.status === "true") {
      setStatus({ loading: false, error: false });
      setAlertMsg(response.data.message);
      reset();
      onShowAlert();
      history.push("/folder/memberList/memberList");
    } else {
      setAlertMsg(response.data.message);
      onShowAlert();
      setStatus({ loading: false, error: true });
    }
  //  console.log(response);
    setStatus({ loading: false, error: false });
  };

  const isMatched = confirmPassword.length > 0 && confirmPassword !== password;

  const handleSignatureFileChanges = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSignature(event.target.files[0]);
    } else {
      setSignature(null);
    }
  };

  const handleSignatureFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) return;
    const files = Array.from(event.target.files);
    if (files.length > 5) {
      alert("You can only upload up to 5 signatures.");
      return;
    } else {
    }

    setSignatures(files);  
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
    } else {
      setFile(null);
    }
  };

  useEffect(() => {
    getSecurityQuestion();
    return () => {};
  }, []);
  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar className={styles.headerToolbar}>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle className={styles.headerTitle}>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>

        <Box
          sx={{
            maxWidth: "1000px",
            margin: "auto",
          }}
        >
          <Box
            sx={{
              paddingTop: "20px",
              "& > :not(style)": { m: 1 },
            }}
          >
            <Typography variant="h5">Personal Information</Typography>
            <Divider orientation="horizontal" flexItem />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="First Name"
              error={!!errors.firstName}
              {...register("firstName")}
              helperText={errors.firstName?.message}
              value={firstName}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setFirstName(event.target.value);
              }}
            />
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Middle Name"
              error={!!errors.middleName}
              {...register("middleName")}
              // helperText={'this field is optional'}
              value={middleName}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setMiddleName(event.target.value);
              }}
            />
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              error={!!errors.lastName}
              {...register("lastName")}
              helperText={errors.lastName?.message}
              label="Enter Last Name"
              value={lastName}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setLastName(event.target.value);
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
  //           sx={{
  //   display: "flex",
  //   alignItems: "center", // align properly
  //   gap: 2, // spacing between fields
  // }}
          >
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              type="email"
              label="Email"
              value={email}
              error={!!errors.email}
              {...register("email")}
              helperText={errors.email?.message ?? " "}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEmail(event.target.value);
              }}
              
            />
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Enter Phone"
              error={!!errors.phone}
              {...register("phone")}
              // helperText={
              //   errors.phone ? errors.phone?.message : "Preferably whatsapp"
              // }
              helperText={errors.phone?.message ?? "Preferably whatsapp"}
              value={phone}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setPhone(event.target.value);
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Titles</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                error={!!errors.titles}
                {...register("titles")}
                // helperText={errors.titles?.message}
                value={titles}
                label="Titles"
                onChange={(event: SelectChangeEvent) => {
                  setTitles(event.target.value as string);
                }}
              >
                <MenuItem value="Mr.">Mr.</MenuItem>
                <MenuItem value="Mrs.">Mrs.</MenuItem>
                <MenuItem value="Miss">Miss</MenuItem>
                <MenuItem value="Ms.">Ms.</MenuItem>
                <MenuItem value="Dr.">Dr.</MenuItem>
                <MenuItem value="Prof.">Prof.</MenuItem>
                <MenuItem value="Rev.">Rev.</MenuItem>
                <MenuItem value="Hon.">Hon.</MenuItem>
                <MenuItem value="Eng.">Eng.</MenuItem>
                <MenuItem value="Lt.">Lt.</MenuItem>
                <MenuItem value="Capt.">Capt.</MenuItem>
                <MenuItem value="Col.">Col.</MenuItem>
                <MenuItem value="Gen.">Gen.</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">LGA</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={lga}
                error={!!errors.lga}
                {...register("lga")}
                // helperText={errors.lga?.message}
                label="LGA"
                onChange={(event: SelectChangeEvent) => {
                  setLga(event.target.value as string);
                }}
              >
                <MenuItem value={10}>Ten</MenuItem>
                <MenuItem value={20}>Twenty</MenuItem>
                <MenuItem value={30}>Thirty</MenuItem>
              </Select>
            </FormControl>

            <DatePicker
              sx={{ width: "100%" }}
              label="Date Of Birth"
              value={dob}
              // error={!!errors.dob}
              {...register("dob")}
              // helperText={errors.dob?.message}
              onChange={(newValue: any) => setDob(newValue)}
            />
          </Box>
          <Box sx={{ ml: 1 }}>
            <Typography color={"red"} variant="">
              {errors.titles?.message ||
                errors.dob?.message ||
                errors.lga?.message}
            </Typography>
          </Box>
          {/* <Typography color={"red"} variant="h6">{errors.dob?.message}</Typography> */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              paddingTop: "20px",
              "& > :not(style)": { m: 1 },
            }}
          >
            {" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Residential Address"
              error={!!errors.residentialAddress}
              {...register("residentialAddress")}
              helperText={errors.residentialAddress?.message}
              value={residentialAddress}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setResidentialAddress(event.target.value);
              }}
            />{" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Business Address"
              error={!!errors.businessAddress}
              {...register("businessAddress")}
              helperText={errors.businessAddress?.message}
              value={businessAddress}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setBusinessAddress(event.target.value);
              }}
            />{" "}
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            {" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Parish"
              error={!!errors.parish}
              {...register("parish")}
              helperText={errors.parish?.message}
              value={parish}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setParish(event.target.value);
              }}
            />{" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              error={!!errors.area}
              {...register("area")}
              helperText={errors.area?.message}
              label="Area"
              value={area}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setArea(event.target.value);
              }}
            />{" "}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            {" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Zone"
              error={!!errors.zone}
              {...register("zone")}
              helperText={errors.zone?.message}
              value={zone}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setZone(event.target.value);
              }}
            />{" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Province"
              error={!!errors.province}
              {...register("province")}
              helperText={errors.province?.message}
              value={province}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setProvince(event.target.value);
              }}
            />{" "}
          </Box>

          <Box
            sx={{
              paddingTop: "20px",
              "& > :not(style)": { m: 1 },
            }}
          >
            <h5>Next of kin Information</h5>
            <Divider orientation="horizontal" flexItem />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            {" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Next of kin name"
              value={nextOfKin}
              error={!!errors.nextOfKin}
              {...register("nextOfKin")}
              helperText={errors.nextOfKin?.message}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNextOfKin(event.target.value);
              }}
            />{" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Next of kin Relationship"
              error={!!errors.nextOfKinRelationship}
              {...register("nextOfKinRelationship")}
              helperText={errors.nextOfKinRelationship?.message}
              value={nextOfKinRelationship}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNextOfKinRelationship(event.target.value);
              }}
            />{" "}
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            {" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Next of kin phone number"
              error={!!errors.nextOfKinPhone}
              {...register("nextOfKinPhone")}
              helperText={errors.nextOfKinPhone?.message}
              value={nextOfKinPhone}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNextOfKinPhone(event.target.value);
              }}
            />{" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Next Of Kin Address"
              error={!!errors.nextOfKinAddress}
              {...register("nextOfKinAddress")}
              helperText={errors.nextOfKinAddress?.message}
              value={nextOfKinAddress}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNextOfKinAddress(event.target.value);
              }}
            />{" "}
          </Box>

          {/*  */}

          <Box
            sx={{
              paddingTop: "20px",
              "& > :not(style)": { m: 1 },
            }}
          >
            <h5>Account Information</h5>
            <Divider orientation="horizontal" flexItem />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            {" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Enter Bank Account Name"
              value={accountName}
              error={!!errors.accountName}
              {...register("accountName")}
              helperText={errors.accountName?.message}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setAccountName(event.target.value);
              }}
            />{" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Enter Bank Name"
              value={bankName}
              error={!!errors.bankName}
              {...register("bankName")}
              helperText={errors.bankName?.message}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setBankName(event.target.value);
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            {" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Enter Bank Account Number"
              value={accountNumber}
              error={!!errors.accountNumber}
              {...register("accountNumber")}
              helperText={errors.accountNumber?.message}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setAccountNumber(event.target.value);
              }}
            />{" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              type="number"
              label="BVN"
              error={!!errors.bvn}
              {...register("bvn")}
              helperText={
                errors.bvn ? errors.bvn?.message : "Please Enter your BVN"
              }
              value={bvn}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setBvn(event.target.value);
              }}
            />
          </Box>

          <Box>
            {" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Enter Saving Amount"
              error={!!errors.savingAmount}
              {...register("savingAmount")}
              helperText={errors.savingAmount?.message}
              value={savingAmount}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setSavingAmount(event.target.value);
              }}
            />
          </Box>

          <Box
            sx={{
              paddingTop: "20px",
              "& > :not(style)": { m: 1 },
            }}
          >
            <h5>Church Information</h5>
            <Divider orientation="horizontal" flexItem />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            {" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Enter Unit Head Name"
              value={unitHeadName}
              error={!!errors.unitHeadName}
              {...register("unitHeadName")}
              helperText={errors.unitHeadName?.message}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setUnitHeadName(event.target.value);
              }}
            />
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Enter Natual Head Phone"
              error={!!errors.unitHeadPhone}
              {...register("unitHeadPhone")}
              helperText={errors.unitHeadPhone?.message}
              value={unitHeadPhone}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setUnitHeadPhone(event.target.value);
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            {" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Enter Pastor's Name"
              error={!!errors.pastorName}
              {...register("pastorName")}
              helperText={errors.pastorName?.message}
              value={pastorName}
              required
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setPastorName(event.target.value);
              }}
            />{" "}
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Enter Pastor's Phone"
              error={!!errors.pastorPhone}
              {...register("pastorPhone")}
              helperText={errors.pastorPhone?.message}
              value={pastorPhone}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setPastorPhone(event.target.value);
              }}
            />
          </Box>
          <Box
            sx={{
              "& > :not(style)": { m: 1 },
            }}
          >
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Church Address"
              error={!!errors.churchAddress}
              {...register("churchAddress")}
              helperText={errors.churchAddress?.message}
              value={churchAddress}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setChurchAddress(event.target.value);
              }}
            />{" "}
          </Box>
          {/* ////////// */}
          <Box
            sx={{
              paddingTop: "20px",
              "& > :not(style)": { m: 1 },
            }}
          >
            <h5>Upload Documents</h5>
            <Divider orientation="horizontal" flexItem />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            <TextField
              id="upload-passport"
              type="file"
              label="Upload Passport"
              // error={!!errors.accountName}
              // {...register("accountName")}
              // helperText={errors.accountName?.message}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                accept: "image/*", // Accepts only image files
              }}
              fullWidth
              onChange={handleFileChange} // This handles the passport upload
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <PhotoCamera />
                  </InputAdornment>
                ),
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            {/* <TextField
              id="upload-signature"
              type="file"
              label="Upload Signature"
              InputLabelProps={{ shrink: true }}
              inputProps={{
                accept: "image/*", // Accepts only image files
              }}
              fullWidth
              onChange={handleSignatureFileChange} // This handles the signature upload
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <BorderColor />
                  </InputAdornment>
                ),
              }}
            /> */}
            <div>
              <input
                type="file"
                id="file-upload"
                multiple
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleSignatureFileChange}
              />
              <label htmlFor="file-upload">
                <Button variant="contained" component="span">
                  Upload Signatures
                </Button>
              </label>
            </div>
          </Box>
          {/* security section */}
          <Box
            sx={{
              paddingTop: "20px",
              "& > :not(style)": { m: 1 },
            }}
          >
            <Typography variant="h6" color={""}>
              Security Information
            </Typography>
            <Divider orientation="horizontal" flexItem />
          </Box>

          <Box
            sx={{
              display: "flex",
              // alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Security question 1
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={securityQuestion1}
                // error={(securityQuestion1 != '') && (securityQuestion2 == securityQuestion1)}
                error={!!errors.securityQuestion1}
                {...register("securityQuestion1")}
                // helperText={errors.securityQuestion1?.message}
                label="Security Question1"
                onChange={(event: SelectChangeEvent) => {
                  setSecurityQuestion1(event.target.value as string);
                }}
              >
                {allSecurityQuestions.map((question: any, i) => (
                  <MenuItem key={i} value={question?.question}>
                    {question?.question}
                  </MenuItem>
                ))}

                <Typography>{errors.securityQuestion1?.message}</Typography>
              </Select>
            </FormControl>
            <TextField
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Security Answer 1"
              error={!!errors.securityAnswer1}
              {...register("securityAnswer1")}
              helperText={errors.securityAnswer1?.message}
              value={securityAnswer1}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setSecurityAnswer1(event.target.value);
              }}
            />{" "}
          </Box>
          <Box
            sx={{
              display: "flex",
              // alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Security Question 2
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={securityQuestion2}
                // error={
                //   securityQuestion2 != " " &&
                //   securityQuestion2 === securityQuestion1
                // }
                error={!!errors.securityQuestion2}
                {...register("securityQuestion2")}
                label="Please Select security Question 2"
                onChange={(event: SelectChangeEvent) => {
                  setSecurityQuestion2(event.target.value as string);
                }}
              >
                {allSecurityQuestions.map((question: any, i) => (
                  <MenuItem key={i} value={question?.question}>
                    {question?.question}
                  </MenuItem>
                ))}
              </Select>
              <Typography>{errors.securityQuestion2?.message}</Typography>
            </FormControl>
            <TextField
              // helperText="Please select a different question from question 1 "
              id="demo-helper-text-aligned-no-helper"
              fullWidth
              label="Enter Security Answer 2"
              error={!!errors.securityAnswer2}
              {...register("securityAnswer2")}
              helperText={errors.securityAnswer2?.message}
              value={securityAnswer2}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setSecurityAnswer2(event.target.value);
              }}
            />{" "}
          </Box>
          <div>
            <Box
              sx={{
                display: "flex",
                // alignItems: "center",
                "& > :not(style)": { m: 1 },
              }}
            >
              <TextField
                id="demo-helper-text-aligned-no-helper"
                fullWidth
                label="Enter Password"
                error={!!errors.password}
                {...register("password")}
                helperText={errors.password?.message}
                value={password}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setPassword(event.target.value);
                }}
              />{" "}
              <TextField
                error={isMatched}
                // helperText={errors.securityAnswer1?.message}
                helperText={isMatched && "password dosent match"}
                id="demo-helper-text-aligned-no-helper"
                fullWidth
                label="Enter Enter Password again"
                value={confirmPassword}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setConfirmPassword(event.target.value);
                }}
              />{" "}
            </Box>
            {/* {isMatched && <p>password dosent match</p>} */}
          </div>
          {showAlert && (
            <Alert severity={status.error ? "error" : "success"}>
              <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
              {alertMsg?.toUpperCase()}
            </Alert>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& > :not(style)": { m: 1 },
            }}
          >
            <Button
              onClick={handleSubmit(onRegisterHandler)}
              disabled={status.loading}
              variant="contained"
              type="submit"
            >
              {status.loading ? <CircularProgress /> : "Submit"}
            </Button>
          </Box>
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default RegisterMembers;
